import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';


import PearsonEndQuizBlockModal from 'components/TakeQuizPage/PearsonVue/EndQuizBlockModal';
import SVGIcon from 'components/SVGIcon';
import Button from 'components/inputs/Button';
import { Modal as ModalActions, Quizzes } from 'actions/sharedJsActions';


const { modalOpen, modalClose } = ModalActions;
const { quizEndQuizBlock } = Quizzes;

const PearsonVueConfirmationModal = ({ quiz, timeExpired, onFinishSubmit }) => {
  const dispatch = useDispatch();
  const nextBlock = quiz.get('quiz_blocks').find(qb => qb.get('position') === quiz.get('currentQuizBlock').get('position') + 1);
  const breakNext = nextBlock && !nextBlock.get('question_ids').size;

  const goToNextQuizBlock = async (blockNumber) => {
    dispatch(quizEndQuizBlock(quiz.get('id'), blockNumber));
    dispatch(modalClose());
  };

  const offerBreak = () => {
    dispatch(modalOpen((
      <PearsonEndQuizBlockModal
        quiz={quiz}
        closeModal={() => dispatch(modalClose())}
        goToNextQuizBlock={goToNextQuizBlock}
      />
    ), {
      closable: false,
      padding: 0,
      size: 'large'
    }));
  };

  return (
    <div className="PearsonVueConfirmation bg-medium-persian-blue text-white">
      <header className="d-flex justify-content-between align-items-center px-3 pt-3 pb-2">
        <h1> {timeExpired ? 'Time Expired' : quiz.get('name')} </h1>
        <Button styleVariant="none" className="close text-white d-flex" onClick={onFinishSubmit}>
          <SVGIcon name="PearsonVueCloseX" className="mr-1" height={28} width={28} viewBoxHeight="64" viewBoxWidth="64" marginBottom="0" />
        </Button>
      </header>
      <div className="p-4 text-center">
        <h1 className="mt-4 pt-5 d-flex justify-content-center align-items-center">
          <SVGIcon name="PearsonVueInfo" className="mr-4" height={40} width={40} viewBoxHeight="64" viewBoxWidth="64" marginBottom="0" />
          {timeExpired ? 'Your time has expired. Click OK to continue.' : 'The CAT Assessment has been completed. Submit to see your results'}
        </h1>
        <Button styleVariant="pearsonVue" onClick={breakNext ? offerBreak : onFinishSubmit} className="mb-3 mt-5 text-white" large>{timeExpired ? 'Ok' : 'Submit'}</Button>
      </div>
    </div>
  );
};

PearsonVueConfirmationModal.propTypes = {
  quiz: PropTypes.object,
  timeExpired: PropTypes.bool,
  onFinishSubmit: PropTypes.func
};

export default PearsonVueConfirmationModal;
